import { Component, Inject } from '@angular/core';
import { DtoAgentVM } from '../../../Model/agents/DtoAgentVM';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../Shared/Services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../../environments/environment'
import { UserType } from '../../../Shared/Enums/UserType';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AgentsService } from '../../../Services/agents.service';

@Component({
  selector: 'app-view-supplier',
  templateUrl: './view-supplier.component.html',
  styleUrl: './view-supplier.component.scss'
})
export class ViewSupplierComponent {
  SupplierInfo!: DtoAgentVM;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  imgPath: string = environment.ImgUrl;
  selectedId?: number;

  constructor(private toastrService: CustomToastrService, private auth: AuthService, private router: Router,
    private spinner: NgxSpinnerService, private agentApi: AgentsService,
    @Inject(MAT_DIALOG_DATA) public data: ViewSupplierComponent, private dialogRef: MatDialogRef<ViewSupplierComponent>) {
    this.selectedId = data?.selectedId;
  }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Agent])) {
      this.spinner.show();
      this.GetAgentData(this.selectedId);
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetAgentData(agentId: any) {
    if (this.auth.isAuthenticated([UserType.Agent])) {
      this.agentApi.GetAgentData(agentId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any) => {
            this.spinner.hide();
            if (data.isCompleted) {
              this.SupplierInfo = data.result.payload;
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
